var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_34779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.625 408.735H851.381V591.1L778.138 518.895L671.716 586.471L564.041 518.894L470.765 647.568L369.976 690.152L325.529 635.534L290.472 556.848L257.293 604.06L183.423 512.414L132.09 523.522L74.497 450.391L0 422.62L0.625 408.735Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.607 426.836H677.388V392.565H665.801C664.752 392.279 664.193 391.737 663.975 390.741V372.01C664.117 371.617 664.369 371.279 664.849 371.138H677.42L677.31 341.534H663.816V334.311H653.975L654.017 302.913L662.107 302.927L662.149 296.612H629.846V302.961H638.022V334.47H618.101V341.645H604.551V371.053H617.178C617.704 371.18 618.001 371.507 618.104 371.979V390.864C617.881 391.836 617.202 392.522 616.238 392.73H604.607V426.836Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.946 355.383V350.025L618.479 349.053L618.538 334.905L638.46 334.925V302.523H630.264L630.283 297.067L661.698 297.057L661.677 302.494L653.575 302.466L653.533 334.756L663.365 334.751L663.422 348.891L667.306 349.55L667.464 355.581L614.946 355.383Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.837 386.32H625.409V792.19H656.837V386.32Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.939 786.911C642.939 787.779 642.085 788.482 641.031 788.482C639.977 788.482 639.123 787.779 639.123 786.911C639.123 786.043 639.977 785.34 641.031 785.34C642.085 785.339 642.939 786.042 642.939 786.911Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.653 782.312H638.878V785.006H649.653V782.312Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.551 654.805H641.572V665.58H650.551V654.805Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.908 703.29C633.941 703.128 633.366 703.411 631.265 700.259V542.446H634.52V698.688L639.571 699.698L639.908 703.29Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.315 696.675L638.259 693.523L635.166 691.624V664.638H653.181V691.703L650.019 693.562L650.056 696.716L638.315 696.675Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.006 696.147V698.607L640.799 705.75H651.436V699.798H653.102V696.147H635.006Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.051 762.217C654.051 763.271 653.624 764.127 653.098 764.129C652.57 764.131 652.143 763.279 652.143 762.224C652.143 762.222 652.143 762.22 652.143 762.217C652.141 761.163 652.568 760.307 653.096 760.305C653.622 760.303 654.05 761.155 654.051 762.209C654.051 762.212 654.051 762.217 654.051 762.217Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.051 754.136C654.051 755.19 653.624 756.046 653.098 756.048C652.57 756.05 652.143 755.198 652.143 754.143C652.143 754.141 652.143 754.139 652.143 754.136C652.141 753.082 652.568 752.226 653.096 752.224C653.622 752.222 654.05 753.074 654.051 754.128C654.051 754.13 654.051 754.134 654.051 754.136Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.051 745.605C654.051 746.659 653.624 747.515 653.098 747.517C652.57 747.519 652.143 746.667 652.143 745.613C652.143 745.611 652.143 745.609 652.143 745.606C652.141 744.552 652.568 743.696 653.096 743.694C653.622 743.692 654.05 744.544 654.051 745.598C654.051 745.6 654.051 745.605 654.051 745.605Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.051 737.299C654.051 738.353 653.624 739.209 653.098 739.211C652.57 739.213 652.143 738.361 652.143 737.307C652.143 737.305 652.143 737.303 652.143 737.3C652.141 736.246 652.568 735.39 653.096 735.388C653.622 735.386 654.05 736.238 654.051 737.293V737.299Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.051 729.106C654.051 730.16 653.624 731.016 653.098 731.018C652.57 731.02 652.143 730.168 652.143 729.114C652.143 729.112 652.143 729.11 652.143 729.107C652.141 728.053 652.568 727.197 653.096 727.195C653.622 727.193 654.05 728.045 654.051 729.1C654.051 729.1 654.051 729.104 654.051 729.106Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.051 721.136C654.051 722.19 653.624 723.046 653.098 723.048C652.57 723.05 652.143 722.198 652.143 721.144C652.143 721.142 652.143 721.14 652.143 721.137C652.141 720.083 652.568 719.227 653.096 719.225C653.622 719.223 654.05 720.075 654.051 721.13V721.136Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.164 763.927L641.832 769.324L646.355 769.403L653.181 763.927L653.341 704.956H635.165L635.164 763.927Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.051 778.605C654.051 779.659 653.624 780.515 653.098 780.517C652.57 780.519 652.143 779.667 652.143 778.612C652.143 778.61 652.143 778.608 652.143 778.605C652.141 777.551 652.568 776.695 653.096 776.693C653.622 776.691 654.05 777.543 654.051 778.598C654.051 778.598 654.051 778.603 654.051 778.605Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.051 770.411C654.051 771.465 653.624 772.321 653.098 772.323C652.57 772.325 652.143 771.473 652.143 770.418C652.143 770.416 652.143 770.414 652.143 770.411C652.141 769.357 652.568 768.501 653.096 768.499C653.622 768.497 654.05 769.349 654.051 770.403C654.051 770.406 654.051 770.409 654.051 770.411Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.348 768.843H636.185V782.312H652.348V768.843Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.551 566.806H641.572V579.377H650.551V566.806Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.246 579.378H635.287V655.703H653.246V579.378Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.449 550.643H640.674V567.704H651.449V550.643Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.449 542.562H640.674V548.848H651.449V542.562Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.245 547.95H638.878V551.542H653.245V547.95Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.143 536.276H628.103V543.46H654.143V536.276Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.449 501.257H640.674V507.543H651.449V501.257Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.817 486.213C630.913 485.1 630.731 483.359 631.827 482.397C633.564 481.105 634.6 480.17 635.306 477.907V436.826C635.12 434.548 633.608 432.343 631.672 431.028L632.388 427.734H635.082L635.629 430.934C637.37 432.551 638.192 434.303 638.393 436.693L638.505 478.129C637.392 481.958 635.846 483.347 634.269 485.463L630.817 486.213Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.909 484.196H635.174C635.732 484.196 636.184 484.549 636.184 484.982V507.655C636.184 508.088 635.731 508.441 635.174 508.441H630.909C630.351 508.441 629.899 508.088 629.899 507.655V484.982C629.899 484.548 630.351 484.196 630.909 484.196Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.245 507.542H629.001V518.317H653.245V507.542Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.041 518.318H627.205V535.379H655.041V518.318Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.449 413.258H640.674V494.971H651.449V413.258Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.347 494.073H639.776V501.257H652.347V494.073Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.306 358.484H611.94V362.076H670.306V358.484Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.521 386.372V362.184L627.113 358.592H654.944L658.485 362.128V386.372L656.661 388.196H625.317L623.521 386.372Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.528 355.818H677.388H604.528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.528 355.818H677.388",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.551 293.832H641.572V408.769H650.551V293.832Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.347 407.871H639.776V414.157H652.347V407.871Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.857 782.758C634.857 783.75 634.254 784.554 633.51 784.554C632.765 784.554 632.163 783.75 632.163 782.758C632.163 781.767 632.765 780.962 633.51 780.962C634.254 780.962 634.857 781.766 634.857 782.758Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.857 774.676C634.857 775.668 634.254 776.472 633.51 776.472C632.765 776.472 632.163 775.668 632.163 774.676C632.163 773.685 632.765 772.88 633.51 772.88C634.254 772.88 634.857 773.685 634.857 774.676Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.857 766.707C634.857 767.699 634.254 768.503 633.51 768.503C632.765 768.503 632.163 767.699 632.163 766.707C632.163 765.716 632.765 764.911 633.51 764.911C634.254 764.911 634.857 765.716 634.857 766.707Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.857 758.064C634.857 759.056 634.254 759.86 633.51 759.86C632.765 759.86 632.163 759.056 632.163 758.064C632.163 757.073 632.765 756.268 633.51 756.268C634.254 756.268 634.857 757.073 634.857 758.064Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.857 749.983C634.857 750.975 634.254 751.779 633.51 751.779C632.765 751.779 632.163 750.975 632.163 749.983C632.163 748.992 632.765 748.187 633.51 748.187C634.254 748.187 634.857 748.992 634.857 749.983Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.857 741.677C634.857 742.669 634.254 743.473 633.51 743.473C632.765 743.473 632.163 742.669 632.163 741.677C632.163 740.686 632.765 739.881 633.51 739.881C634.254 739.881 634.857 740.686 634.857 741.677Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.857 733.483C634.857 734.475 634.254 735.279 633.51 735.279C632.765 735.279 632.163 734.475 632.163 733.483C632.163 732.492 632.765 731.687 633.51 731.687C634.254 731.687 634.857 732.492 634.857 733.483Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.857 725.289C634.857 726.281 634.254 727.085 633.51 727.085C632.765 727.085 632.163 726.281 632.163 725.289C632.163 724.298 632.765 723.493 633.51 723.493C634.254 723.494 634.857 724.298 634.857 725.289Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.582 786.686C629.582 787.801 629.181 788.708 628.686 788.71C628.189 788.714 627.786 787.81 627.786 786.695C627.786 786.691 627.786 786.69 627.786 786.686C627.784 785.571 628.186 784.664 628.682 784.662C629.177 784.66 629.58 785.562 629.582 786.679C629.582 786.681 629.582 786.684 629.582 786.686Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.582 778.268C629.582 779.383 629.181 780.29 628.686 780.292C628.189 780.296 627.786 779.392 627.786 778.277C627.786 778.273 627.786 778.272 627.786 778.268C627.784 777.153 628.186 776.246 628.682 776.244C629.177 776.242 629.58 777.144 629.582 778.261C629.582 778.263 629.582 778.266 629.582 778.268Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.582 770.523C629.582 771.638 629.181 772.545 628.686 772.547C628.189 772.551 627.786 771.647 627.786 770.532C627.786 770.528 627.786 770.527 627.786 770.523C627.784 769.408 628.186 768.501 628.682 768.499C629.177 768.497 629.58 769.399 629.582 770.516C629.582 770.518 629.582 770.521 629.582 770.523Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.582 762.33C629.582 763.445 629.181 764.352 628.686 764.354C628.189 764.358 627.786 763.454 627.786 762.339C627.786 762.335 627.786 762.334 627.786 762.33C627.784 761.215 628.186 760.308 628.682 760.306C629.177 760.304 629.58 761.206 629.582 762.323C629.582 762.323 629.582 762.328 629.582 762.33Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.582 753.575C629.582 754.69 629.181 755.597 628.686 755.599C628.189 755.603 627.786 754.699 627.786 753.584C627.786 753.58 627.786 753.579 627.786 753.575C627.784 752.46 628.186 751.553 628.682 751.551C629.177 751.549 629.58 752.451 629.582 753.568C629.582 753.568 629.582 753.573 629.582 753.575Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.582 745.605C629.582 746.72 629.181 747.627 628.686 747.629C628.189 747.633 627.786 746.729 627.786 745.614C627.786 745.61 627.786 745.609 627.786 745.605C627.784 744.49 628.186 743.583 628.682 743.581C629.177 743.579 629.58 744.481 629.582 745.598C629.582 745.6 629.582 745.605 629.582 745.605Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.582 737.636C629.582 738.751 629.181 739.658 628.686 739.66C628.189 739.664 627.786 738.76 627.786 737.645C627.786 737.641 627.786 737.64 627.786 737.636C627.784 736.521 628.186 735.614 628.682 735.612C629.177 735.61 629.58 736.512 629.582 737.629C629.582 737.631 629.582 737.634 629.582 737.636Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.582 728.993C629.582 730.108 629.181 731.015 628.686 731.017C628.189 731.021 627.786 730.117 627.786 729.002C627.786 728.998 627.786 728.997 627.786 728.993C627.784 727.878 628.186 726.971 628.682 726.969C629.177 726.967 629.58 727.869 629.582 728.986C629.582 728.988 629.582 728.993 629.582 728.993Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.582 720.8C629.582 721.915 629.181 722.822 628.686 722.824C628.189 722.828 627.786 721.924 627.786 720.809C627.786 720.805 627.786 720.804 627.786 720.8C627.784 719.685 628.186 718.778 628.682 718.776C629.177 718.774 629.58 719.676 629.582 720.793C629.582 720.793 629.582 720.798 629.582 720.8Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.051 786.462C654.051 787.516 653.624 788.372 653.098 788.374C652.57 788.376 652.143 787.524 652.143 786.47C652.143 786.468 652.143 786.466 652.143 786.463C652.141 785.409 652.568 784.553 653.096 784.551C653.622 784.549 654.05 785.401 654.051 786.456C654.051 786.456 654.051 786.46 654.051 786.462Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.909 592.847H653.133C653.691 592.847 654.143 593.2 654.143 593.633V596.551C654.143 596.984 653.69 597.337 653.133 597.337H630.909C630.351 597.337 629.899 596.984 629.899 596.551V593.633C629.899 593.199 630.351 592.847 630.909 592.847Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.909 633.254H653.133C653.691 633.254 654.143 633.607 654.143 634.04V636.958C654.143 637.391 653.69 637.744 653.133 637.744H630.909C630.351 637.744 629.899 637.391 629.899 636.958V634.04C629.899 633.606 630.351 633.254 630.909 633.254Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.909 676.355H653.133C653.691 676.355 654.143 676.708 654.143 677.141V680.059C654.143 680.494 653.69 680.845 653.133 680.845H630.909C630.351 680.845 629.899 680.494 629.899 680.059V677.141C629.899 676.707 630.351 676.355 630.909 676.355Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.215 529.093H654.031C654.589 529.093 655.041 529.446 655.041 529.879V531.001C655.041 531.434 654.588 531.787 654.031 531.787H628.215C627.657 531.787 627.205 531.434 627.205 531.001V529.879C627.205 529.445 627.658 529.093 628.215 529.093Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.501 469.829H652.235C652.793 469.829 653.245 470.182 653.245 470.615V472.635C653.245 473.068 652.792 473.421 652.235 473.421H634.501C633.943 473.421 633.491 473.068 633.491 472.635V470.615C633.491 470.181 633.943 469.829 634.501 469.829Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.501 440.197H652.235C652.793 440.197 653.245 440.55 653.245 440.983V443.003C653.245 443.436 652.792 443.789 652.235 443.789H634.501C633.943 443.789 633.491 443.436 633.491 443.003V440.983C633.491 440.549 633.943 440.197 634.501 440.197Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.98 419.544H629.001V428.523H637.98V419.544Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.185 428.523H629.899V431.217H636.185V428.523Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.287 410.565H629.899V419.544H635.287V410.565Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.98 406.075H629.001V410.565H637.98V406.075Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.287 369.259H629.899V406.075H635.287V369.259Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.185 322.566H629.899V341.423H636.185V322.566Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.082 339.627H628.103V369.259H637.082V339.627Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.734 318.171L549.514 318.133C545.92 318.104 540.808 322.188 540.877 326.77V347.168H538.02L537.98 326.69C538.015 320.739 543.285 315.475 549.453 315.494L610.762 315.453L610.734 318.171Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.838 314.485H610.144V319.873H612.838V314.485Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.205 313.587H611.94V320.771H627.205V313.587Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.901 323.492C628.919 322.442 628.115 321.423 627.084 321.454L627.135 312.307L629.452 312.312C634.224 312.379 637.453 316.827 637.41 321.474V323.546L628.901 323.492Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.112 376.87V375.025H612.724V376.911L609.112 376.87Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.358 371.399V375.092L608.2 375.934H613.588L614.486 375.036V371.389L607.358 371.399Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.367 377.046V375.199H672.978V377.085L669.367 377.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.611 371.574V375.267L668.453 376.109H673.841L674.739 375.211V371.564L667.611 371.574Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.349 335.498V337.343H672.96V335.458L669.349 335.498Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.594 340.989V337.296L668.436 336.454H673.824L674.722 337.352V340.999L667.594 340.989Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.069 335.597V337.442H612.68V335.557L609.069 335.597Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.314 341.069V337.376L608.156 336.534H613.544L614.442 337.432V341.079L607.314 341.069Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.511 368.361H623.613V370.157H624.511V368.361Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.511 371.953H623.613V373.749H624.511V371.953Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.633 371.953H657.735V373.749H658.633V371.953Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.633 368.361H657.735V370.157H658.633V368.361Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.439 305.281V307.146L636.01 307.136L636.021 305.301L632.439 305.281Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.565 303.496V306.234H636.883V303.496H631.565Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.54 305.182V307.047L655.967 307.036L655.958 305.201L659.54 305.182Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.414 303.396V306.135H655.096V303.396H660.414Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.083 296.526H636.185V297.424H637.083V296.526Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.143 296.526H653.245V297.424H654.143V296.526Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.077 341.476V348.715L614.515 349.669V355.955",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.077 341.476V348.715L614.515 349.669V355.955",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.829 341.532L663.871 348.547L667.474 349.513V355.843",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.829 341.532L663.871 348.547L667.474 349.513V355.843",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.813 354.529L620.785 357.239L620.813 354.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.813 354.529L620.785 357.239",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.207 354.541V357.229V354.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.207 354.541V357.229",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.387 357.586H668.51V362.974H678.387V357.586Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.736 357.586H603.859V362.974H613.736V357.586Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.165 359.382H595.777V361.178H601.165V359.382Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.733 363.98H601.006L600.078 363.051V357.724L601.022 356.779H603.701L603.733 363.98Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.47 359.382H681.082V361.178H686.47V359.382Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.255 363.982H680.98L681.909 363.053V357.726L680.964 356.78H678.23L678.255 363.982Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.327 290.24H630.797V295.628H661.327V290.24Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.143 270.486H637.98V290.241H654.143V270.486Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.553 288.011V286.146L635.126 286.157L635.137 287.992L631.553 288.011Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.681 289.797V287.058H635.999V289.797H630.681Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.305 288.011V286.146L656.732 286.157L656.723 287.992L660.305 288.011Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.178 289.797V287.058H655.86V289.797H661.178Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.206 288.011V286.146L648.635 286.157L648.624 287.992L652.206 288.011Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.079 289.797V287.058H647.761V289.797H653.079Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.652 287.996V286.131L643.225 286.141L643.234 287.976L639.652 287.996Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.78 289.781V287.043H644.098V289.781H638.78Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.602 272.814V274.679L635.175 274.669L635.186 272.834L631.602 272.814Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.73 271.029V273.767H636.048V271.029H630.73Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.354 272.814V274.679L656.781 274.669L656.772 272.834L660.354 272.814Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.227 271.029V273.767H655.909V271.029H661.227Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.255 272.814V274.679L648.684 274.669L648.673 272.834L652.255 272.814Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.129 271.029V273.767H647.811V271.029H653.129Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.701 272.83V274.695L643.274 274.685L643.283 272.85L639.701 272.83Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.83 271.044V273.782H644.148V271.044H638.83Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.327 264.2H630.797V270.486H661.327V264.2Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.327 232.772H630.797V239.058H661.327V232.772Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.327 239.956H630.797V263.302H661.327V239.956Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.546 230.612V228.747L635.117 228.757L635.128 230.592L631.546 230.612Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.673 232.397V229.659H635.991V232.397H630.673Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.296 230.612V228.747L656.725 228.757L656.714 230.592L660.296 230.612Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.17 232.397V229.659H655.852V232.397H661.17Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.143 224.691H637.98V232.772H654.143V224.691Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.197 230.612V228.747L648.626 228.757L648.615 230.592L652.197 230.612Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.07 232.397V229.659H647.752V232.397H653.07Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.645 230.595V228.73L643.216 228.74L643.227 230.575L639.645 230.595Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.771 232.382V229.643H644.089V232.382H638.771Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.83 224.797L635.168 223.001V209.498L656.722 209.529V223.032L653.967 224.859L637.83 224.797Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.185 219.502L631.529 215.845V210.348L632.438 209.439H635.099L635.185 219.502Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.736 219.414L660.326 215.778V210.434L659.386 209.492H656.692L656.736 219.414Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.219 207.702V198.721H648.608V201.478H650.465V205.009H648.638V207.704L643.219 207.702Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.449 207.63H640.674V209.426H651.449V207.63Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.916 220.378L644.12 218.451V209.516H647.712V218.451L645.916 220.378Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.459 201.803L652.223 201.795L652.239 200.006L653.098 199.115H654.027L654.925 199.991L654.934 206.27L654.052 207.191H653.115L652.24 206.231L652.224 204.504L650.467 204.535L650.459 201.803Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.869 192C651.869 195.25 649.234 197.884 645.985 197.884C642.735 197.884 640.101 195.249 640.101 192C640.101 188.75 642.736 186.116 645.985 186.116C649.234 186.116 651.869 188.751 651.869 192Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.001 192.015L648.695 193.796L646.001 192.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.001 192.015L648.695 193.796",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.497 191.985C646.497 192.25 646.281 192.464 646.017 192.464C645.753 192.464 645.537 192.249 645.537 191.985C645.537 191.72 645.752 191.505 646.017 191.505C646.282 191.505 646.497 191.719 646.497 191.985Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.96 251.629H646.062V252.527H646.96V251.629Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.326 244.445H667.612V259.71H705.326V244.445Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.511 239.956H662.225V264.2H668.511V239.956Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.102 240.854H670.306V243.548H672.102V240.854Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.204 239.956H669.408V244.446H671.204V239.956Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.102 247.139H670.306V249.833H672.102V247.139Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.306 246.241H668.51V250.731H670.306V246.241Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.102 254.323H670.306V257.017H672.102V254.323Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.306 253.425H668.51V257.915H670.306V253.425Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.102 260.608H670.306V263.302H672.102V260.608Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.306 259.71H668.51V264.2H670.306V259.71Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.714 239.956H704.428V264.2H710.714V239.956Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.632 240.854H700.836V243.548H702.632V240.854Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.53 239.956H701.734V244.446H703.53V239.956Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.632 247.139H700.836V249.833H702.632V247.139Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.53 246.241H701.734V250.731H703.53V246.241Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.632 254.323H700.836V257.017H702.632V254.323Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.53 253.425H701.734V257.915H703.53V253.425Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.632 260.608H700.836V263.302H702.632V260.608Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.53 259.71H701.734V264.2H703.53V259.71Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.898 239.956H711.612V264.2H717.898V239.956Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.754 265.996H730.468V273.18H736.754V265.996Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.833 240.946V264.31C730.328 268.806 736.668 268.789 741.151 264.31L741.17 240.946H725.833Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.746 259.744H725.801C729.324 254.576 729.235 249.5 725.801 244.545H717.746V259.744Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.489 240.854H719.693V243.548H721.489V240.854Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.693 239.956H717.897V244.446H719.693V239.956Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.489 247.139H719.693V249.833H721.489V247.139Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.693 246.241H717.897V250.731H719.693V246.241Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.489 254.323H719.693V257.017H721.489V254.323Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.693 253.425H717.897V257.915H719.693V253.425Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.489 260.608H719.693V263.302H721.489V260.608Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.693 259.71H717.897V264.2H719.693V259.71Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.937 252.165C698.928 258.872 693.483 264.301 686.776 264.292C680.084 264.283 674.659 258.859 674.65 252.165C674.641 245.458 680.069 240.014 686.776 240.005C693.483 239.996 698.928 245.425 698.937 252.132C698.937 252.142 698.937 252.153 698.937 252.165Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.007 255.578C680.011 256.629 679.162 257.485 678.11 257.49C677.058 257.494 676.202 256.644 676.198 255.592C676.198 255.588 676.198 255.583 676.198 255.579C676.194 254.527 677.045 253.671 678.095 253.667C679.147 253.663 680.003 254.513 680.007 255.565C680.007 255.569 680.007 255.574 680.007 255.578Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.067 248.693C680.071 249.745 679.222 250.601 678.17 250.605C677.118 250.609 676.262 249.759 676.258 248.707C676.258 248.702 676.258 248.698 676.258 248.694C676.254 247.642 677.105 246.786 678.155 246.782C679.207 246.778 680.063 247.628 680.067 248.68C680.067 248.684 680.067 248.688 680.067 248.693Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.953 243.604C684.957 244.656 684.106 245.512 683.054 245.516C682.003 245.52 681.148 244.67 681.142 243.619C681.142 243.614 681.142 243.61 681.142 243.605C681.138 242.554 681.989 241.698 683.041 241.694C684.093 241.689 684.949 242.54 684.953 243.591C684.953 243.595 684.953 243.599 684.953 243.604Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.339 243.558C692.344 244.61 691.494 245.466 690.442 245.47C689.39 245.474 688.534 244.624 688.53 243.573C688.53 243.568 688.53 243.563 688.53 243.559C688.526 242.508 689.377 241.652 690.429 241.648C691.48 241.643 692.335 242.494 692.339 243.545C692.339 243.549 692.339 243.554 692.339 243.558Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.087 260.776C685.091 261.828 684.24 262.684 683.188 262.688C682.137 262.692 681.282 261.842 681.276 260.79C681.276 260.786 681.276 260.781 681.276 260.777C681.272 259.725 682.123 258.87 683.175 258.865C684.227 258.861 685.083 259.711 685.087 260.763C685.087 260.767 685.087 260.772 685.087 260.776Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.35 248.712C697.354 249.763 696.503 250.619 695.451 250.623C694.399 250.627 693.543 249.777 693.539 248.726C693.539 248.721 693.539 248.717 693.539 248.713C693.535 247.661 694.386 246.805 695.438 246.801C696.49 246.797 697.344 247.647 697.35 248.699C697.35 248.703 697.35 248.708 697.35 248.712Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.35 255.657C697.354 256.709 696.503 257.565 695.451 257.569C694.399 257.573 693.543 256.723 693.539 255.671C693.539 255.666 693.539 255.662 693.539 255.658C693.535 254.607 694.386 253.751 695.438 253.747C696.49 253.743 697.344 254.592 697.35 255.644C697.35 255.648 697.35 255.653 697.35 255.657Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.309 260.737C692.313 261.789 691.462 262.645 690.412 262.649C689.36 262.653 688.504 261.803 688.5 260.751C688.5 260.747 688.5 260.742 688.5 260.738C688.496 259.686 689.345 258.83 690.397 258.826C691.449 258.822 692.305 259.672 692.309 260.724C692.309 260.728 692.309 260.732 692.309 260.737Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.693 284.116L684.607 251.725C685.144 248.659 689.446 249.278 688.904 252.54L683.269 285.107C682.618 288.125 677.995 287.063 678.693 284.116Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.247 252.125C687.247 252.387 687.033 252.6 686.77 252.6C686.509 252.6 686.295 252.387 686.295 252.125C686.295 251.862 686.509 251.649 686.77 251.649C687.032 251.65 687.247 251.862 687.247 252.125Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.938 272.282H723.285V277.67H743.938V272.282Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.93 235.537C722.698 236.499 722.766 240.988 724.93 241.847H742.033C744.228 240.956 744.252 236.467 742.033 235.537H724.93Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.856 209.426H732.264V214.814H735.856V209.426Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.708 235.537V215.775C730.314 213.548 736.579 213.535 739.334 215.775V235.538L727.708 235.537Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.048 205.893C712.757 205.888 712.658 209.461 715.048 209.505H752.788C755.362 209.438 755.27 205.909 752.788 205.854L715.048 205.893Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.982 357.667V363.11V357.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.982 357.667V363.11",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.024 357.722V363.082V357.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.024 357.722V363.082",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.578 353.148H639.221H641.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.578 353.148H639.221",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.704 353.135H650.347H652.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.704 353.135H650.347",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.595 399.789H510.473V407.87H544.595V399.789Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.844 346.93V326.214C514.835 321.839 510.3 318.203 506.748 318.118H456.469V315.459H506.708C512.116 315.502 517.548 320.248 517.543 326.293V346.929L514.844 346.93Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.288 347.709H507.779V399.79H547.288V347.709Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.35 345.913H512.269V347.709H520.35V345.913Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.696 345.913H535.615V347.709H543.696V345.913Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.596 311.791H453.902V321.668H456.596V311.791Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.515 400.687H379.373V406.973H448.515V400.687Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.903 288.444H373.986V400.687H453.903V288.444Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.189 313.587H268.926V318.975H372.189V313.587Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.986 311.791H371.292V321.668H373.986V311.791Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.348 299.328C387.405 298.544 388.293 297.418 389.13 297.448H438.657C439.469 297.426 440.386 298.367 440.411 299.202V326.379",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.348 299.328C387.405 298.544 388.293 297.418 389.13 297.448H438.657C439.469 297.426 440.386 298.367 440.411 299.202V326.379",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.413 301.914H391.944V318.077H405.413V301.914Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.32 299.82L387.334 326.254C387.294 327.062 388.223 328.124 389.074 328.148L437.977 328.145C439.149 328.176 440.06 327.789 440.409 326.437",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.32 299.82L387.334 326.254C387.294 327.062 388.223 328.124 389.074 328.148L437.977 328.145C439.149 328.176 440.06 327.789 440.409 326.437",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.719 307.301H394.638V308.199H402.719V307.301Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.719 309.097H394.638V311.791H402.719V309.097Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.943 301.914H412.597V318.077H435.943V301.914Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.454 305.505H417.087V313.586H431.454V305.505Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.47 537.174H640.674V538.97H642.47V537.174Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.001 537.174H628.103V538.97H629.001V537.174Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.143 537.174H653.245V538.97H654.143V537.174Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.935 783.214H649.57H638.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.935 783.214H649.57",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.157 779.641H652.706H636.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.157 779.641H652.706",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.126 760.832H653.142H635.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.126 760.832H653.142",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.164 758.648H653.221H635.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.164 758.648H653.221",
    stroke: "black",
    strokeOpacity: 0.39,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.164 763.531H653.259L647.08 768.814L641.063 768.788L635.164 763.531Z",
    fill: "white",
    fillOpacity: 0.39,
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.164 707.815H653.259H635.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.164 707.815H653.259",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.436 699.798H636.434H651.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.436 699.798H636.434",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.142 697.972H634.61H653.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.142 697.972H634.61",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.126 693.528H638.499H650.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.126 693.528H638.499",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.061 691.703H635.125H653.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.061 691.703H635.125",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.221 648.129H635.244H653.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.221 648.129H635.244",
    stroke: "black",
    strokeOpacity: 0.39,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.023 645.392H635.324H653.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.023 645.392H635.324",
    stroke: "black",
    strokeOpacity: 0.39,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.844 588.028H634.867H652.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.844 588.028H634.867",
    stroke: "black",
    strokeOpacity: 0.39,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.646 585.291H634.947H652.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.646 585.291H634.947",
    stroke: "black",
    strokeOpacity: 0.39,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.594 568.643H650.284H641.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.594 568.643H650.284",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.482 552.491H651.436H640.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.482 552.491H651.436",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.562 544.396H651.317H640.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.562 544.396H651.317",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.021 539.554H654.014H628.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.021 539.554H654.014",
    stroke: "black",
    strokeOpacity: 0.39,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.799 502.291H650.999H640.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.799 502.291H650.999",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.694 414.938H651.189H640.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.694 414.938H651.189",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.215 522.807H654.031C654.589 522.807 655.041 523.16 655.041 523.593V524.715C655.041 525.148 654.588 525.501 654.031 525.501H628.215C627.657 525.501 627.205 525.148 627.205 524.715V523.593C627.205 523.159 627.658 522.807 628.215 522.807Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.062 197.044L644.188 195.133L643.062 197.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.062 197.044L644.188 195.133",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.839 194.921L642.67 193.831L640.839 194.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.839 194.921L642.67 193.831",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.164 191.944H642.247H640.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.164 191.944H642.247",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.999 189.048L642.791 190.055L640.999 189.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.999 189.048L642.791 190.055",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.14 187.004L644.203 188.735L643.14 187.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.14 187.004L644.203 188.735",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.019 186.19V188.273V186.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.019 186.19V188.273",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.895 187.004L647.859 188.772L648.895 187.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.895 187.004L647.859 188.772",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.018 189.127L649.252 190.084L651.018 189.127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.018 189.127L649.252 190.084",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.773 191.885H649.73H651.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.773 191.885H649.73",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.138 194.881L649.211 193.745L651.138 194.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.138 194.881L649.211 193.745",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.916 197.004L647.841 195.197L648.916 197.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.916 197.004L647.841 195.197",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.863 192.004C651.863 195.254 649.227 197.888 645.977 197.888C642.727 197.888 640.093 195.253 640.093 192.004C640.093 188.755 642.728 186.12 645.977 186.12C649.227 186.12 651.863 188.754 651.863 192.004Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.362 414.233H633.26H630.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.362 414.233H633.26",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.114 414.233H633.24H634.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.114 414.233H633.24",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.879 351.388L632.535 351.374L628.879 351.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.879 351.388L632.535 351.374",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.389 351.374H632.515H633.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.389 351.374H632.515",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.593 358.677V362.248V358.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.593 358.677V362.248",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.403 358.479V362.05V358.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.403 358.479V362.05",
    stroke: "black",
    strokeOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.759 402.169H448.076H379.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.759 402.169H448.076",
    stroke: "black",
    strokeOpacity: 0.39,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.487 401.217H544.081H510.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.487 401.217H544.081",
    stroke: "black",
    strokeOpacity: 0.39,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.729 92.417H157.648V175.028H165.729V92.417Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.873 177.72H114.547V183.108H146.873V177.72Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.927 268.829C144.07 279.155 157.09 278.819 160.682 269.053L162.366 262.543",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.927 268.829C144.07 279.155 157.09 278.819 160.682 269.053L162.366 262.543",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.723 408.233H140.814L140.926 267.032L120.722 266.808L120.723 408.233Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.586 408.458L136.326 267.032H120.724V408.346L136.586 408.458Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.975 262.128H114.547V267.516H145.975V262.128Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.321 182.21H93.894V263.025H169.321V182.21Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.628 187.598H97.486V258.535H166.628V187.598Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.177 245.455C116.177 250.461 112.308 254.52 107.534 254.52C102.761 254.52 98.891 250.461 98.891 245.455C98.891 240.449 102.761 236.39 107.534 236.39C112.308 236.391 116.177 240.449 116.177 245.455Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.9864
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.136 245.493C134.134 250.521 130.263 254.595 125.49 254.593C120.72 254.591 116.853 250.518 116.851 245.493C116.851 240.465 120.721 236.39 125.494 236.39C130.267 236.391 134.136 240.467 134.136 245.493Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.9885
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.095 245.424C152.095 250.413 148.226 254.458 143.452 254.458C138.679 254.458 134.809 250.413 134.809 245.424C134.809 240.434 138.679 236.39 143.452 236.39C148.226 236.391 152.095 240.434 152.095 245.424Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.9847
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.842 245.37C112.842 248.115 110.617 250.34 107.871 250.34C105.126 250.34 102.9 248.114 102.9 245.37C102.9 242.624 105.126 240.399 107.871 240.399C110.617 240.398 112.842 242.624 112.842 245.37Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.801 245.37C130.801 248.115 128.576 250.34 125.83 250.34C123.085 250.34 120.859 248.114 120.859 245.37C120.859 242.624 123.085 240.399 125.83 240.399C128.576 240.398 130.801 242.624 130.801 245.37Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.76 245.37C148.759 248.115 146.533 250.339 143.787 250.338C141.043 250.337 138.82 248.113 138.818 245.37C138.818 242.624 141.044 240.399 143.789 240.399C146.535 240.398 148.76 242.624 148.76 245.37Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.078 192.985H163.036C164.027 192.985 164.832 193.79 164.832 194.781V231.597C164.832 232.588 164.027 233.393 163.036 233.393H101.078C100.086 233.393 99.282 232.588 99.282 231.597V194.781C99.282 193.79 100.085 192.985 101.078 192.985Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.036 196.577H102.874V229.801H163.036V196.577Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.75 175.026H168.423C169.414 175.026 170.219 175.831 170.219 176.822V180.414C170.219 181.406 169.414 182.21 168.423 182.21H156.75C155.758 182.21 154.954 181.406 154.954 180.414V176.822C154.954 175.831 155.758 175.026 156.75 175.026Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.444 81.6406H166.628C168.612 81.6406 170.22 83.2486 170.22 85.2326V89.7226C170.22 91.7066 168.612 93.3146 166.628 93.3146H159.444C157.46 93.3146 155.852 91.7066 155.852 89.7226V85.2326C155.852 83.2486 157.46 81.6406 159.444 81.6406Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.462 86.4346H114.157H155.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.462 86.4346H114.157",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.524 64.8838V107.087V64.8838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.524 64.8838V107.087",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.687 68.5879V103.608V68.5879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.687 68.5879V103.608",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.794 73.1328V99.2858V73.1328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.794 73.1328V99.2858",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.07 78.5776V95.8076V78.5776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.07 78.5776V95.8076",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.682 82.1689V90.6439V82.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.682 82.1689V90.6439",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.341 83.9648V89.1278V83.9648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.341 83.9648V89.1278",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_34779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsp);
export default __webpack_public_path__ + "static/media/esp.9fd6cb58aa7975f9349e6914cc27c1cf.svg";
export { ForwardRef as ReactComponent };